import script from "./ReportsTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsTickets.vue?vue&type=script&setup=true&lang=js"

import "./ReportsTickets.vue?vue&type=style&index=0&id=53eef0e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53eef0e0"]])

export default __exports__